import { useParams, Link } from "react-router-dom";
import { findPolicy } from "../data/policies/index.js";
import NotFound from "./NotFound.jsx";

// Review placeholders are written as [TBC: ...] in the policy text and rendered
// highlighted so they cannot be missed on a preview.
const TBC = /(\[TBC:[^\]]*\])/g;
function rich(text) {
  return String(text).split(TBC).map((part, i) =>
    part.startsWith("[TBC:") ? <mark className="tbc" key={i}>{part}</mark> : part
  );
}

function Body({ items }) {
  return items.map((it, i) => {
    if (typeof it === "string") return <p key={i}>{rich(it)}</p>;
    if (it.ul) return <ul key={i}>{it.ul.map((li, j) => <li key={j}>{rich(li)}</li>)}</ul>;
    if (it.note) return <p className="policy-note" key={i}>{rich(it.note)}</p>;
    if (it.table) {
      return (
        <div className="table-wrap policy-table" key={i}>
          <table>
            <thead><tr>{it.table.head.map((h) => <th key={h}>{h}</th>)}</tr></thead>
            <tbody>
              {it.table.rows.map((r, j) => (
                <tr key={j}>{r.map((c, k) => <td key={k}>{rich(c)}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
    return null;
  });
}

export default function PolicyPage({ slug: fixedSlug }) {
  const params = useParams();
  const slug = fixedSlug || params.slug;
  const policy = findPolicy(slug);
  if (!policy) return <NotFound />;

  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">{policy.tier}</div>
          <h1>{policy.title}.</h1>
          <p className="sub">{policy.lead}</p>
        </div>
      </section>

      <div className="applies-to">
        <div className="wrap">
          <span className="k">Applies to</span>
          <span className="v">{policy.appliesTo}</span>
        </div>
      </div>

      <section className="policy">
        <div className="wrap policy-grid">
          <aside className="policy-contents">
            <div className="eyebrow">On this page</div>
            <ol>
              {policy.sections.map((s) => (
                <li key={s.id}><a href={"#" + s.id}>{s.h}</a></li>
              ))}
            </ol>
            <div className="policy-meta">
              <div><span>Version</span>{policy.version}</div>
              <div><span>Status</span>{policy.status}</div>
              <div><span>Owner</span>{policy.owner}</div>
            </div>
            <Link to="/policies" className="policy-back">All policies</Link>
          </aside>

          <article className="legal-content policy-body">
            {policy.sections.map((s) => (
              <div key={s.id} id={s.id} className="policy-section">
                <h2>{s.h}</h2>
                <Body items={s.body} />
              </div>
            ))}
            <p className="policy-foot">
              {policy.title} v{policy.version}. {policy.status}. Daksfirst Limited, company number 11626401,
              is an Appointed Representative (937220) of Maystone Capital Limited, FRN 758412.
            </p>
          </article>
        </div>
      </section>
    </>
  );
}
